import { createContext, useContext, useState } from "react";

export const AppContext = createContext({
  user: null,
  login: () => { },
  logout: () => { }
})


export default function AppContextProvider({ children }) {

  const [user, setUser] = useState(null)
  const login = (user) => {
    setUser(user)
  }

  const logout = () => {
    setUser(null)
  }

  return <AppContext.Provider value={{ user, login, logout }}>{children}</AppContext.Provider>

}

export const useAuth = () => {
  return useContext(AppContext)
}